import { z } from "zod";
/**
 * Portable account copy (GET /me/export; the attachments an erased account takes with it).
 * Row sections retain database field names and dates serialize as ISO strings. A row is
 * `unknown` here because its columns are the database's contract: packages/db's account-export
 * test reads them from the catalogue and fails until a new column is named or left out on
 * purpose. The api's export test parses a real copy with this schema, and every object is
 * strict, so a section the exporter adds fails that test until it is named here.
 */
const Rows = z.array(z.unknown());
export const AccountExportSchema = z.strictObject({
    scope: z.string(),
    exported_at: z.string(),
    withheld: z.array(z.string()),
    /** The account's own row with its sign-in history; null when the owner has none. */
    account: z.unknown(),
    profile: z.strictObject({
        rows: Rows,
        intakes: Rows,
        baselines: Rows,
        progression: Rows,
        rubric_history: Rows,
        reflections: Rows,
    }),
    engagements: z.array(z.strictObject({
        id: z.string(),
        case_slug: z.string(),
        client: z.string(),
        status: z.string(),
        /** A Date as the exporter returns it, an ISO string once the copy is serialized. */
        created_at: z.unknown(),
        last_event_at: z.unknown(),
        events: Rows,
        documents: Rows,
        recommendation: Rows,
        debrief: Rows,
        assessments: Rows,
        assessment_records: Rows,
        checks: Rows,
        rolls: Rows,
        rulings: Rows,
        facts: Rows,
        fact_record: Rows,
        state: Rows,
        people: Rows,
        summary: Rows,
    })),
    /** Everything the coach keeps (packages/db's exportCoachDataForOwner). */
    coach: z.unknown(),
    library: Rows,
    settings: Rows,
    consents: Rows,
    mail: Rows,
    checkins: Rows,
    model_calls: Rows,
});
//# sourceMappingURL=account-export.js.map